/*
  **Wortgrenzen mit Umlauten.** JavaScripts `\b` kennt nur [A-Za-z0-9_] — vor „ü“ fände es keine
  Grenze, und „@büro“ oder „#Küche“ würden falsch geschnitten. Hier zählt jeder Buchstabe und jede
  Ziffer jeder Schrift (`\p{L}`, `\p{N}`).
*/

const WORD_CHAR = /[\p{L}\p{N}_]/u

export function isWordChar(char: string | undefined): boolean {
  return char !== undefined && WORD_CHAR.test(char)
}

/** Vor `index` beginnt ein neues Wort: Textanfang, Leerraum oder eine öffnende Klammer. */
export function startsWord(text: string, index: number): boolean {
  if (index === 0) return true
  return /[\s([{"„«]/u.test(text[index - 1]!)
}

/**
 * Bei `index` endet ein Wort: Textende, Leerraum oder ein Satzzeichen — aber kein Bindestrich:
 * „Heute-Show“ ist ein Wort, kein „heute“ mit Anhang.
 */
export function endsWord(text: string, index: number): boolean {
  if (index >= text.length) return true
  return /[\s.,;:!?)\]}"“»]/u.test(text[index]!)
}

/** Steht an der Stelle ein Bindestrich — dann gehört der Treffer zu einem zusammengesetzten Wort. */
export function touchesHyphen(text: string, range: { start: number; end: number }): boolean {
  return text[range.start - 1] === '-' || text[range.end] === '-'
}

export interface Word {
  start: number
  end: number
  text: string
}

/** Die Wörter des Titels mit ihrer Stelle — getrennt an Leerraum, Satzzeichen bleiben am Wort. */
export function wordsOf(text: string): Word[] {
  const words: Word[] = []
  for (const match of text.matchAll(/\S+/gu)) {
    words.push({ start: match.index!, end: match.index! + match[0].length, text: match[0] })
  }
  return words
}

/** Überschneiden sich zwei Stellen? Berühren zählt nicht. */
export function overlaps(a: { start: number; end: number }, b: { start: number; end: number }): boolean {
  return a.start < b.end && b.start < a.end
}

/**
 * Der Text mit diesen Stellen durch Unterstriche ersetzt — gleiche Länge, gleiche Positionen.
 *
 * **Unterstriche, keine Leerzeichen:** Vor einer Reihe Leerzeichen las chrono-node „morgen“ als etwas
 * anderes („Lesen       morgen“ → kein Tag; gemessen 03.10.2026). Mit Unterstrichen nicht.
 */
export function mask(text: string, ranges: { start: number; end: number }[]): string {
  let masked = text
  for (const range of ranges) {
    masked = masked.slice(0, range.start) + '_'.repeat(range.end - range.start) + masked.slice(range.end)
  }
  return masked
}
